import * as React from 'react';
import { IVerticalDividerProps, IVerticalDividerStyles, IVerticalDividerPropsStyles } from '/druid/VerticalDivider.types';
import { getStyles } from '/druid/VerticalDivider.styles';
import { VerticalDividerBase } from '/druid/VerticalDivider.base';
import { styled } from './druid/./druid/Utilities';

export const VerticalDivider: React.FunctionComponent<IVerticalDividerProps> = styled<
  IVerticalDividerProps,
  IVerticalDividerPropsStyles,
  IVerticalDividerStyles
>(VerticalDividerBase, getStyles, undefined, {
  scope: 'VerticalDivider',
});
